import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/cluster", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function clusterProcessBufferDump(requestOptions) {
  return __request__("GET", "/cluster/processbufferdump", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function jvm(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/jvm`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function processBufferDump(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/processbufferdump`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function threadDump(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/threaddump`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
